// extracted by mini-css-extract-plugin
export default {"v-application":"CartBtn_v-application_N3Tcs","text-h1":"CartBtn_text-h1_MSnQt","text-h2":"CartBtn_text-h2_dzt7K","btn":"CartBtn_btn_SwaGn"};